import RichText from './RichText';

const getCardDetails = blocks => {
  let cardDetails = {};

  blocks.map(ele => {
    switch (ele?.sys?.contentType?.sys?.id) {
      case 'imageBlock':
        cardDetails['backgroundImage'] = ele.fields?.imagePath || ele.fields.image.fields.file.url;
        cardDetails['mobileBackgroundImage'] =
          ele.fields?.mobileImagePath || ele.fields?.mobileImage?.fields?.file?.url;
        break;

      case 'textBlockWithMobile':
        cardDetails['title'] =
          window.innerWidth < 768 && ele?.fields?.mobileTitle ? ele?.fields?.mobileTitle : ele.fields.title;
        cardDetails['content'] =
          window.innerWidth < 768 && ele?.fields?.mobileContent
            ? RichText(ele?.fields?.mobileContent)
            : RichText(ele?.fields?.content);
        break;
      case 'link':
        cardDetails['url'] = ele?.fields?.url;
        cardDetails['text'] = ele?.fields?.text;
        cardDetails['newtab'] = ele?.fields?.newTabWindow;
      default: {
        return null;
      }
    }
  });
  return cardDetails;
};

export default getCardDetails;
